import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import AssignmentCustomerCard from 'Components/host/taskManagement/AssignmentCustomerCard';
import BackTop from 'Components/common/BackTop';

// Actions
import {
    getF1OrderList,
    updateF1OrderSearchFields,
    updateF1OrderSearchList,
    updateF1OrderReceiveSearchList,
    updateF1OrderDetails,
    updateF1OrderListSearchFields,
    updateF1OrderList,
    updateF1PackageOnTheGoList,
    updateF1OrderTabActive,
    setF1OrderSource,
    updateF1OrderListPageNum,
    setF1OrderOnGoPackageSource,
    updateF1OrderOnGoPackageListPageNum,
    updateF1OnGoPackageSort,
} from 'Actions/host';
import {
    getTaskAssignmentCustomerList,
    updateTaskAssignmentSearchfields,
} from 'Actions/taskManagement';
import {T} from 'Actions/translate';

class TaskManagementList extends React.Component {
    pager = {
        page: 0,
        length: 15,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    packagePager = {
        page: 0,
        length: 15,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };

    state = {
        searchValue: '',
        tabList: [
            {
                index: 0,
                text: T('user_center_task_management_tobe_completed'),
                tabFlag: 1,
            },
            {
                index: 1,
                text: T('user_center_task_management_in_follow_up'),
                tabFlag: 2,
            },
            {
                index: 2,
                text: T('user_center_task_management_all_completed'),
                tabFlag: 3,
            },
        ],
        tabActive: 0,
        listLoaded: true,
    };

    componentWillMount() {
        this.props.updateTaskAssignmentSearchfields({
            queryKey: {$set: ''},
        });
        this.getList();
        this.props.updateF1OrderSearchList([]);
    }

    getRoteParam = () => {
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );

        return routerState;
    };

    getList = () => {
        let taskId =
            typeof this.getRoteParam().id !== 'undefined' &&
            this.getRoteParam().id;

        this.props.setF1OrderSource({$set: false});
        if (this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        let tabFlag =
            typeof this.getRoteParam().tabFlag !== 'undefined' &&
            this.getRoteParam().tabFlag;

        this.props
            .getTaskAssignmentCustomerList({
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                id: taskId,
                queryKey: this.props.queryKey ? this.props.queryKey.trim() : '',
                tabFlag: tabFlag,
            })
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    chooseItem = (item, currentIndex) => {
        let tabFlag =
            typeof this.getRoteParam().tabFlag !== 'undefined' &&
            this.getRoteParam().tabFlag;
        this.props.history.push(`/host/taskDetails/`, {
            id: item.id,
            taskId: item.taskId,
            item: item,
            tabFlag: tabFlag,
        });
    };

    goBack = () => {
        this.props.updateTaskAssignmentSearchfields({
            queryKey: {$set: ''},
        });
        this.props.history.goBack();
    };

    search = () => {
        this.props.updateF1OrderList([]);
        this.props.updateF1OrderListPageNum({$set: 0});
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        this.getList();
    };

    onChange = (title, value) => {
        this.props.updateTaskAssignmentSearchfields({
            [title]: {$set: value},
        });
    };

    render() {
        const {listLoaded} = this.state;
        const {assignmentCustomerList} = this.props;
        let taskName =
            typeof this.getRoteParam().taskName !== 'undefined' &&
            this.getRoteParam().taskName;

        let taskNo =
            typeof this.getRoteParam().taskNo !== 'undefined' &&
            this.getRoteParam().taskNo;
        return (
            <div className="task-management-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="task-management-list-header">
                        <div className="task-management-list-header-title">
                            <h3 className="header-title">
                                {taskNo} {taskName}
                            </h3>
                        </div>

                        <SearchInput
                            title="queryKey"
                            value={this.props.queryKey}
                            placeholder={T(
                                'task_details_assignment_customer_search_placeholder',
                            )}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                </Header>
                <ScrollWrapper
                    listLoaded={listLoaded}
                    showAbyss={this.pager.page >= this.pager.pageTotal}
                    showLoadingMore={!listLoaded}
                    getMoreData={this.getList}>
                    <ul className="task-management-list">
                        {assignmentCustomerList &&
                            assignmentCustomerList.map((item, index) => (
                                <AssignmentCustomerCard
                                    item={item}
                                    index={index + 1}
                                    assignmentCustomerList={
                                        assignmentCustomerList
                                    }
                                    chooseItem={() =>
                                        this.chooseItem(item, index + 1)
                                    }
                                />
                            ))}
                    </ul>
                    <BackTop />
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, taskManagement} = state;
    return {
        F1OrderList: host.F1OrderList,
        F1PackageOnTheGoList: host.F1PackageOnTheGoList,
        tabActive: host.tabActive,
        fromF1OrderDetails: host.fromF1OrderDetails,
        currentF1OrderPageNum: host.currentF1OrderPageNum,
        fromF1OrderOnGoPackageDetails: host.fromF1OrderOnGoPackageDetails,
        currentF1OrderOnGoPackagePageNum: host.currentF1OrderOnGoPackagePageNum,
        f1OngoPackageIsAsc: host.f1OngoPackageIsAsc,

        taskList: taskManagement.taskList,
        assignmentCustomerList: taskManagement.assignmentCustomerList,
        queryKey: taskManagement.taskAssignmentSearchfields.queryKey,
    };
};

const mapDispatchToProps = {
    getF1OrderList,
    updateF1OrderSearchFields,
    updateF1OrderSearchList,
    updateF1OrderReceiveSearchList,
    updateF1OrderDetails,
    updateF1OrderListSearchFields,
    updateF1OrderList,
    updateF1PackageOnTheGoList,
    updateF1OrderTabActive,
    setF1OrderSource,
    updateF1OrderListPageNum,
    setF1OrderOnGoPackageSource,
    updateF1OrderOnGoPackageListPageNum,
    updateF1OnGoPackageSort,

    getTaskAssignmentCustomerList,
    updateTaskAssignmentSearchfields,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskManagementList);
